import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminReportsDataService {
	private ADMIN_URL = '/admin/rest';

	constructor(private http: HttpClient) {}

	getSignUpReport(): Observable<any> {
		const url = `${this.ADMIN_URL}/get-new-sign-ups-report`;
		return this.http.get(url);
	}

	getPayingMembersReport(): Observable<any> {
		const url = `${this.ADMIN_URL}/get-new-paying-members-report`;
		return this.http.get(url);
	}

	getCancellationReport(): Observable<any> {
		const url = `${this.ADMIN_URL}/get-new-cancellations-report`;
		return this.http.get(url);
	}

	getTotalRevenueReport(): Observable<any> {
		const url = `${this.ADMIN_URL}/get-total-revenue-report`;
		return this.http.get(url);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/services/admin/users/admin-reports.data.service.ts